import { useContext, useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Context } from '../../Context';
import ApartmentTile from './ApartmentTile';
import styles from '../../styles/bim.module.scss';

function FavoriteApartments() {
	const {
		isDesktop,
		favoriteApartmentUUIDs,
		filteredApartmentData,
		removeAllFavoritesHandler,
		activeApartment,
		favoritesViewRef,
		projectSetup,
	} = useContext(Context);
	const { t } = useTranslation();
	const favoritesListRef = useRef(null);
	const [isDragging, setIsDragging] = useState(false);
	const [startX, setStartX] = useState(0);
	const [scrollLeftStart, setScrollLeftStart] = useState(0);

	const showPrice = projectSetup.website.are_apartment_prices_visible || false;

	const areSomeFavoritesHiddenByFilter = favoriteApartmentUUIDs.some(
		(favUuid) =>
			!filteredApartmentData.some((apartment) => apartment.uuid === favUuid)
	);
	const visibleFavoriteApartmentsDetails = filteredApartmentData.filter(
		(apartment) => favoriteApartmentUUIDs.includes(apartment.uuid)
	);

	useEffect(() => {
		const element = favoritesListRef.current;
		if (!element) return;

		const handleWheel = (e) => {
			if (element.scrollWidth <= element.clientWidth) {
				return;
			}

			const { deltaY } = e;
			if (deltaY === 0) return;

			const currentScrollLeft = element.scrollLeft;
			const maxScrollLeft = element.scrollWidth - element.clientWidth;

			const atLeftEdge = currentScrollLeft <= 0;
			const atRightEdge = currentScrollLeft >= maxScrollLeft - 1;

			if ((deltaY < 0 && atLeftEdge) || (deltaY > 0 && atRightEdge)) {
				return;
			}

			e.preventDefault();
			element.scrollLeft += deltaY;
		};

		element.addEventListener('wheel', handleWheel, { passive: false });

		return () => {
			element.removeEventListener('wheel', handleWheel);
		};
	}, [visibleFavoriteApartmentsDetails.length]);

	const handleMouseDown = (e) => {
		if (!favoritesListRef.current || e.button !== 0) return;
		const element = favoritesListRef.current;
		setIsDragging(true);
		setStartX(e.pageX);
		setScrollLeftStart(element.scrollLeft);
		element.style.cursor = 'grabbing';
		element.style.userSelect = 'none';
};
const handleMouseLeaveOrUp = () => {
	if (!favoritesListRef.current || !isDragging) return;
	setIsDragging(false);
	favoritesListRef.current.style.cursor = 'grab';
	favoritesListRef.current.style.userSelect = '';
};
const handleMouseMove = (e) => {
	if (!isDragging || !favoritesListRef.current) return;
	e.preventDefault();
	const currentX = e.pageX;

	const numFavorites = favoriteApartmentUUIDs.length;
	const baseSpeedMultiplier = 1.5;
	const additionalSpeedMultiplier = Math.min(4.5, Math.max(0, (numFavorites - 5) * 0.05));
	const scrollSpeedMultiplier = baseSpeedMultiplier + additionalSpeedMultiplier;

	const walk = (currentX - startX) * scrollSpeedMultiplier;
	favoritesListRef.current.scrollLeft = scrollLeftStart - walk;
};

	if (isDesktop && 
			(!favoriteApartmentUUIDs || 
				favoriteApartmentUUIDs.length === 0
			)
		) {
		return null;
	}
	return (
		<div
			id="favorites"
			ref={favoritesViewRef}
			style={{
				maxWidth: '1320px',
				margin: 'auto',
				// padding: isDesktop 
				// 	? activeApartment 
				// 		? '0 0 92px 0' 
				// 		: '92px 0' 
				// 	: '0 0.5rem',
				padding: 'var(--section-padding) 0 0 0',
			}}
		>
				<div className={styles.top_bar_favorites}>
					<h2>
						{t('favorites')}
						{` (${
							areSomeFavoritesHiddenByFilter
								? `${visibleFavoriteApartmentsDetails.length}/`
								: ''
						}${favoriteApartmentUUIDs.length})`}
					</h2>
					{areSomeFavoritesHiddenByFilter && (
						<p style={{ display: 'inline-block' }}>{t('favorites_filtered')}</p>
					)}
					{
						<button
							className={`${styles.plan_button} ${styles.plan_button_text}`}
							onClick={() => removeAllFavoritesHandler()}
						>
							{t('favorites_remove_all')}
						</button>
					}
				</div>
			{visibleFavoriteApartmentsDetails.length > 0 ? (
				<div 
				className={styles.favorites_list}
				ref={favoritesListRef}
				onMouseDown={handleMouseDown}
				onMouseLeave={handleMouseLeaveOrUp}
				onMouseUp={handleMouseLeaveOrUp}
				onMouseMove={handleMouseMove}
				style={{ cursor: 'grab' }}
				>
					{visibleFavoriteApartmentsDetails.map((apartment) => (
						<ApartmentTile 
						key={apartment.uuid} 
						apartmentData={apartment} 
						showPrice={showPrice}
						/>
					))}
				</div>
			) : "Lista ulubionych jest pusta. Kliknij w ikonę serca na karcie lokalu, żeby dodać go do listy ulubionych i tu zobaczyć."}
		</div>
	);
}

export default FavoriteApartments;
